// src/pages/Inicio.js
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authReady } from "../firebase";

const VISIBLE_FROM_KEY = {
  estadio: "Estadio",
  torrecardenas: "Torrecardenas",
  rambla: "Rambla",
};
const KEY_FROM_VISIBLE = {
  Estadio: "estadio",
  Torrecardenas: "torrecardenas",
  Rambla: "rambla",
};
const PASSWORDS = {
  Estadio: "0627",
  Torrecardenas: "1010",
  Rambla: "1351",
};

export default function Inicio() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState(null);
  const [almacenKey, setAlmacenKey] = useState(null);

  // Estado del formulario de login
  const [selRest, setSelRest] = useState("Estadio");
  const [pwd, setPwd] = useState("");
  const [loginErr, setLoginErr] = useState("");

  useEffect(() => {
    authReady.then((u) => setUsuario(u));
    const k = (sessionStorage.getItem("almacenKey") || "").toLowerCase();
    setAlmacenKey(k || null);
  }, []);

  const tieneSesionValida = useMemo(
    () =>
      almacenKey === "estadio" ||
      almacenKey === "torrecardenas" ||
      almacenKey === "rambla",
    [almacenKey]
  );

  const almacenVisible = useMemo(
    () => (tieneSesionValida ? VISIBLE_FROM_KEY[almacenKey] : null),
    [tieneSesionValida, almacenKey]
  );

  const cerrarSesion = () => {
    sessionStorage.removeItem("almacenKey");
    setAlmacenKey(null);
    setPwd("");
    setLoginErr("");
  };

  const irInventario = () => navigate("/inventario");
  const irCrearUtensilio = () => navigate("/crear");

  const intentarLogin = (e) => {
    e?.preventDefault?.();
    const expected = PASSWORDS[selRest];
    if (!expected) {
      setLoginErr("Selecciona un restaurante válido.");
      return;
    }
    if (pwd.trim() !== expected) {
      setLoginErr("Contraseña incorrecta.");
      return;
    }
    // OK → guardar sesión
    const key = KEY_FROM_VISIBLE[selRest];
    sessionStorage.setItem("almacenKey", key);
    setAlmacenKey(key);
    setPwd("");
    setLoginErr("");
  };

  return (
    <div className="max-w-3xl mx-auto mt-16 bg-white/80 backdrop-blur-md p-8 rounded-2xl shadow-lg">
      <h1 className="text-4xl font-extrabold mb-4 text-slate-800">
        Gestor de Utensilios
      </h1>
      <p className="text-slate-600 mb-6">
        Bienvenido. Desde aquí puedes crear utensilios o consultar el inventario.
      </p>

      {/* Si NO hay sesión → mostrar login */}
      {!tieneSesionValida ? (
        <>
          <div className="mb-6 rounded-xl border border-amber-300 bg-amber-50 text-amber-800 p-4">
            <p className="font-semibold">Debes iniciar sesión</p>
            <p className="text-sm">
              Selecciona tu restaurante (Estadio, Torrecardenas o Rambla) e introduce la contraseña.
            </p>
          </div>

          <form
            onSubmit={intentarLogin}
            className="bg-slate-50 border border-slate-200 rounded-xl p-4 flex flex-col gap-3"
          >
            <label className="text-slate-700 text-sm font-medium">
              Restaurante
            </label>
            <select
              className="border rounded-lg px-3 py-2"
              value={selRest}
              onChange={(e) => setSelRest(e.target.value)}
            >
              <option>Estadio</option>
              <option>Torrecardenas</option>
              <option>Rambla</option>
            </select>

            <label className="text-slate-700 text-sm font-medium">
              Contraseña
            </label>
            <input
              className="border rounded-lg px-3 py-2"
              type="password"
              placeholder="••••"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
            />

            {loginErr && (
              <div className="text-red-600 text-sm">{loginErr}</div>
            )}

            <div className="flex gap-3 pt-2">
              <button
                type="submit"
                className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition"
              >
                Iniciar sesión
              </button>
            </div>
          </form>
        </>
      ) : (
        <>
          {/* Con sesión → mostrar estado y botones */}
          <div className="flex items-center justify-between bg-slate-50 p-4 rounded-xl border border-slate-200 mb-6">
            <div>
              <p className="text-slate-600">Sesión</p>
              <p className="font-semibold text-slate-800">{almacenVisible}</p>
            </div>
            <button
              onClick={cerrarSesion}
              className="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-lg transition"
            >
              Cerrar sesión
            </button>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-4">
            <button
              onClick={irCrearUtensilio}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-xl shadow-md transition"
            >
              Crear utensilio
            </button>

            <button
              onClick={irInventario}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-800 font-semibold py-3 px-4 rounded-xl shadow-md transition"
            >
              Ir al inventario
            </button>
          </div>
        </>
      )}
    </div>
  );
}
